export type AppType =
  | 'dstation'
  | 'dstation-oem'
  | 'dstation-oem-covid'
  | 'dnext'
  | 'cportal'
  | 'cportal-sgzp-app2'
  | 'cportal-sgzp-app4'
  | 'cportal-sgzp-app5'
  | 'cportal-sgzp-app6'
  | 'cportal-hicrea-sso'
  | 'cportal-aiss-sso'
  | 'cportal-aihobs-ecs'
  | 'cportal-sgzp-master'
  | 'dr-dish'
  | 'sas-station'
  | 'suguyaku'
  | 'welltect'
  | 'hayfever'
  | 'sas-clinic'
  | 'traders'
  | 'cportal-connect'
  | 'wellbean'
  | 'lasuite'
  | 'sokusai'
  | 'sokusai-management'
  | 'sas-management'
  | 'healthpicks'
  | 'healthpicks-operator';

export type Products = 'cp_products' | 'doctors_products';
/** type毎のプロダクト設定 */
export const productsPerType: Partial<Record<AppType, Products[]>> = {
  // cp系はcp_products
  cportal: ['cp_products'],
  'cportal-sgzp-app2': ['cp_products'],
  dnext: ['doctors_products'],
  'cportal-sgzp-app4': ['cp_products'],
  'cportal-sgzp-master': ['cp_products'],
  'cportal-hicrea-sso': ['cp_products'],
  'cportal-aiss-sso': ['cp_products'],
  'cportal-aihobs-ecs': ['cp_products'],
  // それ以外の未設定はデフォルト doctors_products
};

export type AppProperties = {
  appUrl: string;
  clientId?: string;
  /** 未使用 @deprecated */
  domain?: string;
  faviconUrl: string;
  /** 未使用 @deprecated */
  title?: string;
  pageTitle?: string;
  type: AppType;
  privacyUrl?: string;
  termUrl?: string;
  /** デフォルトコネクション以外を使う場合 */
  connection?:
    | 'CBPT-DxSales'
    | 'LINE'
    | 'CBPT-Kanri'
    | 'DST-OEM'
    | 'DST-SOKUSAI-OEM'
    | 'CBPT-MR'
    | 'DST-HEALTHPICKS';
  /** アカウント連携機能を有効化するか否か.デフォルト有効にしない
   *  https://doctors-jp.backlog.com/view/DXUT-63
   */
  isEnableAccountIntegration?: boolean;
  /** 自治体OEM向け */
  oemConfig?: {
    id?: 'new-osaka' | 'EAJ' | 'thedoc';
    /** アプリ名 */
    name?: string;
    pref: string;
    imgpath: string;
  };
  dstationConfig?: {
    // https://drsdevelopmentteam.slack.com/archives/C04EXRSFGG6/p1724727440400139
    isHideLoginPageComponent?: {
      /** ヘッダ部を非表示とするか否か */
      header?: boolean;
      /** ページ下部のほかページリンク類 */
      pageLinks?: boolean;
      // 各要素単位での表示・非表示を制御する必要が出たら以下をを追加する
      /** 新規登録ボタン */
      registerButton?: boolean;
      /** パスワード再設定リンク */
      /** メール再送信リンク */
      /** 利用規約リンク */
    };
    /** ログインページ上部に表示する説明文。 */
    loginDescription?: string;
  };
  /**
   * ログインページのカスタムドメイン設定
   * redirect_uriのドメインをカスタムドメインに変更する
   **/
  customDomainConfig?: {
    baseUrl: string;
  };
  /** 各タイミングでデフォルトURL以外を利用する場合 */
  customUrls?: {
    onUpdatePasswordFinish?: string;
    /** メール認証完了時に遷移するURL. 未指定の場合はappUrl */
    onEmailVerificationFinish?: string;
    /** アプリのトップ画面へのURL. ログインその後ログイン画面へリダイレクトされるURLを想定 */
    gotoAppTop?: string;
  };
  dxSales?: {
    updatedPasswordLink: {
      dxSales: string;
      sgzpApp4: string;
      sgzpApp6: string;
    };
  };
  sgzpApp2?: {
    /** webviewの判定 */
    isFromNativeApp: boolean;
    /** 新規登録ページURL */
    registerUrl: string;
    /** ブロック解除時URL */
    unblockRedirectUrl: string;
    /** お知らせAPI */
    loginMessageUrl: string;
    /** コラボポータルのclient_id */
    cportalClientId: string;
  };
  sgzpApp4?: {
    /** コラボポータルのclient_id */
    cportalClientId: string;
  };
  sgzpApp6?: {
    /** コラボポータルのclient_id */
    cportalClientId: string;
  };
  hicreaSso?: {
    /** コラボポータルのclient_id */
    cportalClientId: string;
  };
  aissSso?: {
    /** コラボポータルのclient_id */
    cportalClientId: string;
  };
  aihobsEcs?: {
    /** コラボポータルのclient_id */
    cportalClientId: string;
  };
  sgzpMaster?: {
    /** コラボポータルのclient_id */
    cportalClientId: string;
  };
  sessionMinutes?: number;
  /** Google タグ マネージャー */
  gtm?: {
    id: string;
  };
  /** コラボポータルconnect向け設定. 連携処理サイト向け */
  'cportal-connect-config'?: {
    /** パスワードを忘れた方で登録するURL */
    passwordResetUrl: string;
  };
  /** コラボポータルconnect向け設定. コラボポータル向け */
  'cportal-connect-config-for-collaboportal'?: {
    /** 連携処理サイトのclient_id */
    clientId: string;
    /** 連携処理サイトのredirect_uri */
    redirectUri: string;
    /** Doctors Nextのclient_id */
    dnextClientId: string;
  };
  dnextConfig?: {
    apiBaseUrl: string;
  };
  customErrorMessages?: {
    // ログイン失敗時のカスタムエラーメッセージ. 20250209時点, 個別実装時に参照する必要がある
    login?: {
      'Wrong email or password.'?: string;
    };
  };
  /** コラボポータル向け設定 */
  cportalConfig?: {
    logoImagePath?: string;
    forgotPassword?: {
      withoutLogin?: boolean;
    };
  };
  // ローディングのスピナー設定
  spinner?: {
    autologin?: {
      isHide: boolean;
    };
  };
};

export type EnvironmentType = {
  production: boolean;
  domain: string;
  audience: string;
  baseUri: string;
  sessionStorageKey: string;
  tmpClientId: string;
  apps: Record<string, AppProperties>;
};
